


























import { Component, Vue, Prop } from 'vue-property-decorator';
import Typography from '@/components/atoms/Typography/Typography.vue';
import Picture from '@/components/atoms/Picture/Picture.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import CoinsIcon from '@/components/icons/Coins.vue';

@Component({
  components: {
    Typography,
    Picture,
    FilledButton,
    CoinsIcon
  }
})
export default class CouponPreview extends Vue {
  @Prop({ default: '0' }) value?: string;

  get businessCurrency() {
    return this.$store.getters['internationalization/getCountrySettings']
      .currencySymbol;
  }
}
